module.exports = __webpack_public_path__ + "img/batteri-ladeniveau-forside.ed6e25a3.svg";